import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        showModal: false,
        meetings: []
    },
    mutations: {
        setMeetings(state, data) {
            state.meetings = data
        },
        showModal(state) {
            state.showModal = true
        },
        hideModal(state) {
            state.showModal = false
        }
    },
    actions: {
        setMeetings(vuexContext, data) {
            vuexContext.commit('setMeetings', data)
        },
        showModal(vuexContext) {
            vuexContext.commit('showModal')
        },
        hideModal(vuexContext) {
            vuexContext.commit('hideModal')
        }
    },
    getters: {
        getMeetings(state) {
            return state.meetings
        }
    }
})
